// @module C3.ShoppingExtensions.System8Page
define('C3.ShoppingExtensions.System8Page.List.View'
,	[
	'c3_shoppingextensions_system8page_list.tpl'
	,	'SCView'
	,   'Utils'

    ]
, function (
	c3_shoppingextensions_system8page_list_tpl
	,	SCViewModule
	,   Utils
)
{
    'use strict';

     var SCView = SCViewModule.SCView;

     function System8PageListView (options) {
     	SCView.call(this, options);

	     	this.template = c3_shoppingextensions_system8page_list_tpl;
	      this.options = options;
			this.category = options.categoryinfo;
			this.subcategoryinfo = options.subcategoryinfo;
			this.application = options.application;
     }

     System8PageListView.prototype = Object.create(SCView.prototype);
     System8PageListView.prototype.constructor = System8PageListView;

     System8PageListView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    System8PageListView.prototype.getContext = function () {


			var values = [];
			var self = this;

			var fullurl = Backbone.history.fragment;
       		var url = fullurl.split('?')[0];

			_.each(this.subcategoryinfo, function(category) {
	            values.push({
	                displayName: category.name,
	                label: category.name,
	                link: category.fullurl,
	                isActive: category.fullurl === Utils.correctURL(url)
	            });
	        });

    	return {
    			subcategories : values
    	}
    }

     return System8PageListView;
});
